module.exports = __webpack_public_path__ + "img/house-milton-grove_b2.bc4ae8d4.jpg";